module.exports = __webpack_public_path__ + "static/media/logo-full-mono.45596539.svg";